const t = {
    icon: 'fa-file',
    display: {
        properties: [
           'customerName','project','contractName','contractRate','tenant','dateStart','dateEnd','expenses','earnings','bills'
        ],
    }
};

export default t;